/**
 * @generated SignedSource<<3fe3f3a5fde1baa2af7e4cff1961a7b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCompanySupportWebsite_company$data = {
  readonly preferences: {
    readonly support: {
      readonly website: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PaymentCompanySupportWebsite_company";
};
export type PaymentCompanySupportWebsite_company$key = {
  readonly " $data"?: PaymentCompanySupportWebsite_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanySupportWebsite_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCompanySupportWebsite_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferencesSupport",
          "kind": "LinkedField",
          "name": "support",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "website",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "91f7c194712bf1de6efc50c2dd35080c";

export default node;
